const IScroll = require("iscroll");
const $ = require("jquery");
require("jquery-drawer");

$(document).ready(function () {
    $(".drawer").drawer({
        iscroll: {
            mouseWheel: false,
        },
    });
});
